

















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'NavBarRight',
})
export default class NavBarRight extends Vue {
    @Prop(Number) private totalPrice: number;
    @Prop(Number) private totalProducts: number;
}
